export const typePolicies = {
    Test: {
        fields: {
            completionStatus: {
                keyArgs: []
            }
        }
    }
};
